import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { delugeIdAtom } from '@root/entities/auth'
import { BestDealView } from '@root/features/portfolio/best-deal/ui'
import { FollowUserButton } from '@root/features/user/activity-actions/follow-user-button'
import { UserProfileHeader } from '@root/features/user/profile-header/ui/desktop/user-profile-header'
import { type ClassNameProps } from '@root/shared/react'
import { PnLShareBestDealModal } from '@root/widgets/trade/pnl-share-drawer/ui/pnl-share-modal'

import { LatestPostsBoard } from '../board/latest-posts-board/latest-posts-board'

import type { AsyncStateN } from '@blade/std-lib'
import type { Profile } from '@root/entities/profile/model'
import type { DelugeId } from '@root/entities/user-short/model'

type Props = {
  delugeId: DelugeId
  state: AsyncStateN.AsyncStateN<unknown, Profile.Profile>
} & ClassNameProps

export const BoardSidebar: React.FC<Props> = ({
  className,
  delugeId,
  state,
}) => {
  const [currentDelugeId] = useAtom(delugeIdAtom)
  const profile = state.value
  const bestDeal = profile?.bestDeal
  const [bestDealOpen, setBestDealOpen] = useState(false)
  const isCurrentUser = !delugeId || delugeId === currentDelugeId

  return (
    <Root className={className}>
      <UserProfileHeader profileState={state} delugeId={delugeId} />
      {isCurrentUser ? undefined : (
        <FollowUserButton
          delugeId={delugeId}
          fullWidth
          color="primary"
          variant="solid"
          type="button"
          radius="rounded"
        />
      )}

      {bestDeal ? (
        <>
          <BestDealView
            background="cells"
            onShare={() => {
              setBestDealOpen(true)
            }}
            bestDeal={bestDeal}
          />
          <PnLShareBestDealModal
            user={profile}
            open={bestDealOpen}
            onOpenChange={setBestDealOpen}
            bestDeal={bestDeal}
          />
        </>
      ) : undefined}
      <LatestPostsBoard delugeId={delugeId} />
    </Root>
  )
}

const Root = styled.div`
  min-height: 0;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;

  & > * {
    flex: 0 0 auto;
  }

  & > :last-child {
    flex: 1 1 auto;
    min-height: 0;
  }
`
